import createHeartComponent, {
    type SaveAdProps,
} from '@finn-no/favorite-heart-component';
import React from 'react';
import { useAppConfig } from '../AppConfig';
import { useRootElement } from './RootElement';

type FavoriteHeartProps = Omit<
    SaveAdProps,
    'isMobile' | 'itemId' | 'itemType'
> & {
    itemId: string;
};

export function FavoriteHeart(props: FavoriteHeartProps) {
    const { itemId, ...passThroughProps } = props;

    const { isProbablyMobile, favoriteUrl, loginId } = useAppConfig();
    const { rootElement } = useRootElement();

    const Heart = React.useMemo(
        () =>
            createHeartComponent({
                baseUri: favoriteUrl,
                modalAttach: rootElement,
                renderServerSide: true,
                userId: loginId,
            }),
        [favoriteUrl, loginId, rootElement],
    );

    return (
        <Heart
            isMobile={isProbablyMobile}
            itemId={itemId as unknown as number}
            itemType="Ad"
            {...passThroughProps}
        />
    );
}
